const orderHistoryReducer = (state = [], {type,data}) => {
    switch(type) {
        case 'SET_ORDER_HISTORY':
            return data;
        default:
            return state;
    }
}

export default orderHistoryReducer;